import { createApiConfig } from "@oneapp/data";
import type { ApiEndpointsMap } from "@oneapp/data";

/**
 * Build createApiConfig endpoints from flat env endpoint map.
 * Keys match host app (including legacy typos: tenantManagmant, newPeekmindTiken, selflearnWbeSocket).
 */
function buildEndpointsConfig(e: ApiEndpointsMap) {
  return {
    learnGateway: {
      name: "learnGateway",
      baseURL: e.learnGateway,
      description: "Learn Gateway service",
    },
    comService: {
      name: "comService",
      baseURL: e.comService,
      description: "Communication service",
    },
    oms: { name: "oms", baseURL: e.oms, description: "OMS service" },
    oneOms: {
      name: "oneOms",
      baseURL: e.oneOms,
      description: "One OMS service",
    },
    cms: { name: "cms", baseURL: e.cms, description: "CMS service" },
    oneCms: {
      name: "oneCms",
      baseURL: e.oneCms,
      description: "One CMS service",
    },
    assetRendering: {
      name: "assetRendering",
      baseURL: e.assetRendering,
      description: "Asset rendering service",
    },
    masterData: {
      name: "masterData",
      baseURL: e.masterData,
      description: "Master data service",
    },
    tenantManagmant: {
      name: "tenantManagmant",
      baseURL: e.tenantManagement,
      description: "Tenant management service",
    },
    newQB: {
      name: "newQB",
      baseURL: e.newQB,
      description: "New Question Bank service",
    },
    assessment: {
      name: "assessment",
      baseURL: e.assessment,
      description: "Assessment service",
    },
    oneAsm: {
      name: "oneAsm",
      baseURL: e.oneAsm,
      description: "One Assessment service",
    },
    doubts: {
      name: "doubts",
      baseURL: e.doubts,
      description: "Doubts service",
    },
    doubtsAi: {
      name: "doubtsAi",
      baseURL: e.doubtsAI,
      description: "Doubts AI service",
    },
    doubtsDCAPI: {
      name: "doubtsDCAPI",
      baseURL: e.doubtsDCAPI,
      description: "Doubts DCAPI service",
    },
    doubtsQB: {
      name: "doubtsQB",
      baseURL: e.doubtsQB,
      description: "Doubts Question Bank",
    },
    wizklub: {
      name: "wizklub",
      baseURL: e.wizklub,
      description: "Wizklub service",
    },
    peekmind: {
      name: "peekmind",
      baseURL: e.peekmind,
      description: "Peekmind service",
    },
    peekMindReport: {
      name: "peekMindReport",
      baseURL: e.peekMindReport,
      description: "Peekmind report service",
    },
    peekmindOnResume: {
      name: "peekmindOnResume",
      baseURL: e.peekmindOnResume,
      description: "Peekmind resume service",
    },
    newPeekmindTiken: {
      name: "newPeekmindTiken",
      baseURL: e.newPeekmindToken,
      description: "New Peekmind token service",
    },
    newPeekmindQuiz: {
      name: "newPeekmindQuiz",
      baseURL: e.newPeekmindQuiz,
      description: "New Peekmind quiz service",
    },
    learn: { name: "learn", baseURL: e.learn, description: "Learn service" },
    liveclass: {
      name: "liveclass",
      baseURL: e.liveclass,
      description: "Live class service",
    },
    liveclassSocket: {
      name: "liveclassSocket",
      baseURL: e.liveclassSocket,
      description: "Live class websocket",
    },
    eos: { name: "eos", baseURL: e.eos, description: "EOS service" },
    oneApp: {
      name: "oneApp",
      baseURL: e.oneApp,
      description: "One App / One Learn service",
    },
    aina: { name: "aina", baseURL: e.aina, description: "AINA service" },
    uam: {
      name: "uam",
      baseURL: e.uam,
      description: "User Access Management",
    },
    myActivity: {
      name: "myActivity",
      baseURL: e.myActivity,
      description: "My Activity service",
    },
    dataReport: {
      name: "dataReport",
      baseURL: e.dataReport,
      description: "Data report service",
    },
    search: {
      name: "search",
      baseURL: e.search,
      description: "Search service",
    },
    selflearn: {
      name: "selflearn",
      baseURL: e.selflearn,
      description: "Self learn service",
    },
    selflearnWbeSocket: {
      name: "selflearnWbeSocket",
      baseURL: e.selflearnWebSocket,
      description: "Self learn websocket",
    },
    lsqManagement: {
      name: "lsqManagement",
      baseURL: e.lsqManagement,
      description: "LSQ Management (LeadSquared)",
    },
    lsqService: {
      name: "lsqService",
      baseURL: e.lsqService,
      description: "LSQ Service (device attributes, etc.)",
    },
  };
}

export function createDoubtsApiConfig(apiEndpoints: ApiEndpointsMap) {
  return createApiConfig({
    defaultEndpoint: "learnGateway",
    endpoints: buildEndpointsConfig(apiEndpoints),
  });
}
